import { render, staticRenderFns } from "./TintometricoLinha.vue?vue&type=template&id=08e865b0"
import script from "./TintometricoLinha.vue?vue&type=script&lang=js"
export * from "./TintometricoLinha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports